import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const opts = { withCredentials: true };

/** Seed defaults only when the tenant has no roles yet (avoid slow re-upserts). */
async function seedIfEmpty(listFn) {
  const rows = await listFn();
  if (Array.isArray(rows) && rows.length > 0) return rows;
  await axios.post(`${API}/api/tenant-admin/rbac/seed`, {}, opts);
  return listFn();
}

export const rbacApi = {
  seed: () => axios.post(`${API}/api/tenant-admin/rbac/seed`, {}, opts).then((r) => r.data),
  listRoles: (activeOnly = false) =>
    axios
      .get(`${API}/api/tenant-admin/roles`, { ...opts, params: { active_only: activeOnly } })
      .then((r) => r.data),
  /** Fast path for pages — skips seed when data already exists. */
  loadRoles: (activeOnly = false) =>
    seedIfEmpty(() => rbacApi.listRoles(activeOnly)),
  createRole: (body) => axios.post(`${API}/api/tenant-admin/roles`, body, opts).then((r) => r.data),
  updateRole: (roleKey, body) =>
    axios.patch(`${API}/api/tenant-admin/roles/${encodeURIComponent(roleKey)}`, body, opts).then((r) => r.data),
  listPermissions: () => axios.get(`${API}/api/tenant-admin/permissions`, opts).then((r) => r.data),
  loadPermissions: () => seedIfEmpty(() => rbacApi.listPermissions()),
  mapPermissions: (roleKey, permission_codes) =>
    axios
      .put(
        `${API}/api/tenant-admin/roles/${encodeURIComponent(roleKey)}/permissions`,
        { permission_codes },
        opts,
      )
      .then((r) => r.data),
  listSpecialisations: (activeOnly = false) =>
    axios
      .get(`${API}/api/tenant-admin/specialisations`, {
        ...opts,
        params: { active_only: activeOnly },
      })
      .then((r) => r.data),
  loadSpecialisations: (activeOnly = false) =>
    seedIfEmpty(() => rbacApi.listSpecialisations(activeOnly)),
  createSpecialisation: (body) =>
    axios.post(`${API}/api/tenant-admin/specialisations`, body, opts).then((r) => r.data),
  updateSpecialisation: (id, body) =>
    axios.patch(`${API}/api/tenant-admin/specialisations/${id}`, body, opts).then((r) => r.data),
};
